module.exports = "pegasus_template/assets/notes-card.png";